import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {
    returns: [],
    business: null,
    totals: {
      totalSalePrice: 0,
      totalFinalPrice: 0,
      totalQuantity: 0,
      totalItems: 0
    },
    dateRange: {
      start: null,
      end: null,
      days: 0
    },
    filters: {
      viewMode: "product",
      hideZeroSales: false
    }
  },
  loading: false,
  error: null,
};

const returnPercentageReportSlice = createSlice({
  name: "returnPercentageReport",
  initialState,
  reducers: {
    returnPercentageReportRequest(state) {
      state.loading = true;
      state.error = null;
    },
    returnPercentageReportSuccess(state, action) {
      state.loading = false;
      state.data = action.payload;
    },
    returnPercentageReportFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    resetReturnPercentageReport(state) {
      state.loading = false;
      state.error = null;
      state.data = initialState.data;
    },
    updateReturnPercentageFilters(state, action) {
      state.data.filters = {
        ...state.data.filters,
        ...action.payload
      };
    },
  },
});

export const {
  returnPercentageReportRequest,
  returnPercentageReportSuccess,
  returnPercentageReportFailure,
  resetReturnPercentageReport,
  updateReturnPercentageFilters,
} = returnPercentageReportSlice.actions;

export default returnPercentageReportSlice.reducer;